import React from 'react'
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import HomeIcon from '@material-ui/icons/Home';

function WebMapPage(props){
    function iFrame() {
      
        return {
          __html:
            // '<iframe src="https://samplemapac.amlana21.repl.co/mappage?name=newmap"  class="webmapiframe"></iframe>'
            `<iframe src="${process.env.REACT_APP_API_HOST}/mappage?name=${props.mapSrcName.split('.')[0]}"  class="webmapiframe"></iframe>`
        };
      }

      function clickHome(){

        props.clickHome(true)
      }
    return <div className='webmappagemain'>
        <Fab  aria-label="home" size="medium" onClick={clickHome} >
            <HomeIcon />
        </Fab>
        <div className='webmapiframe' dangerouslySetInnerHTML={iFrame()} />
        </div>
}

export default WebMapPage